__turbopack_context__.v({
  "gold": "styles-module-scss-module__jcaocq__gold",
  "green": "styles-module-scss-module__jcaocq__green",
  "orange": "styles-module-scss-module__jcaocq__orange",
  "pink": "styles-module-scss-module__jcaocq__pink",
  "purple": "styles-module-scss-module__jcaocq__purple",
  "root": "styles-module-scss-module__jcaocq__root",
  "teal": "styles-module-scss-module__jcaocq__teal",
  "timerSection": "styles-module-scss-module__jcaocq__timerSection",
  "widgetContainer": "styles-module-scss-module__jcaocq__widgetContainer",
});
